import * as React from "react";
import * as _ from "lodash";
import { IMetricOptions, IMetricData} from "@curefit/metrics-common";
import {
    ConsultationPrescriptionItemRequest,
    UserGoalView,
    Goal
} from "@curefit/gmf-common";
import { IPatientDetail, IDoctorCheckInInfo } from "@curefit/care-common";
import {IAppState} from "../../models/IAppState"
import {connect} from "react-redux"
import AppUtils from "../../utils/AppUtils";
import {PatientCompleteInfoActions} from "../../actions/PatientCompleteInfoActions";
import DietPlanEditViewCont from "../EditView/DietPlanEditViewCont";
import IAccountData from "../../models/IAccountData";
import ModelFactory from "../../models/ModelFactory";
import {EditViewDisplayMode} from "../../components/common/EditViewCard";
import FitnessPlanEditViewCont from "../EditView/FitnessPlanEditViewCont";
import IEditedBy from "../../models/IEditedBy";
import MindfulnessPlanEditViewCont from "../EditView/MindfulnessPlanEditViewCont";
import HabitsPlanEditViewCont from "../EditView/HabitsPlanEditViewCont";
import IMetric from "../../models/metrics/IMetric";
import {AllStaticDataActions} from "../../actions/AllStaticDataActions";
import {CheckinType} from "../../utils/AppConstants";
import {LCGoalEditViewCont} from "../EditView/LCGoalEditViewCont";
import {EventNames} from "../../utils/EventTrackerConstants";

export interface PatientLifestyleContainerProps {
    getPatientPlanForView: (secondaryUserId: string) => Promise<any>,
    patientDetails: IPatientDetail,
    accountData: IAccountData,
    planDetails: any,
    patientGoalsData: UserGoalView[],
    getPatientMetrics: (metricReq: IMetricOptions) => void,
    staticGoals: Goal[],
    staticMetrics: IMetric[],
    fetchPlanStaticData: () => void,
    patientMetrics: {[metricId: number]: IMetricData[]}
}

export interface PatientLifestyleContainerState {
    isLoadingData: boolean
}

class PatientLifestyleContainer extends React.Component<PatientLifestyleContainerProps, PatientLifestyleContainerState> {
    private loadStartTime: number = AppUtils.getCurrentTime()
    constructor(props: PatientLifestyleContainerProps) {
        super(props);
        this.state = {
            isLoadingData: true
        }
    }

    fetchPatientPlanForView = (patientDetails: IPatientDetail): Promise<any> => {
        const {id} = patientDetails;
        return this.props.getPatientPlanForView(
            id.toString(),
        ).then(() => {
            AppUtils.updatePageLoadEvent(EventNames.All_Lifestyle, "", this.loadStartTime)
            this.setState({isLoadingData: false});
        }).catch(() => {
            this.setState({isLoadingData: false});
        })
    };

    componentDidMount () {
        this.fetchPatientPlanForView(this.props.patientDetails);
    }

    componentWillReceiveProps(nextProps: Readonly<PatientLifestyleContainerProps>): void {
        if (this.props.patientDetails.id !== nextProps.patientDetails.id) {
            this.loadStartTime = AppUtils.getCurrentTime()
            this.fetchPatientPlanForView(nextProps.patientDetails);
        }
    }

    getDietPrescriptionFromPlan = () => {
        return this.props.planDetails && !_.isEmpty(this.props.planDetails.dietPlan) ? this.props.planDetails.dietPlan : {};
    }

    generatePatientReferrals = () => {
        let referrals: IDoctorCheckInInfo[] = [];
        if (!_.isEmpty(this.props.planDetails) && !_.isEmpty(this.props.planDetails.consultationsByLifestyleCoach)) {
            _.map(this.props.planDetails.consultationsByLifestyleCoach, (consultation: ConsultationPrescriptionItemRequest) => {
                if (!_.isEmpty(consultation.activities) && consultation.activities[0].checkinType === CheckinType.REFERRAL)
                    referrals.push(ModelFactory.getAlbusReferralFromConsultationPlan(consultation))
            })
        }
        return referrals;
    }

    generatePatientFollowUps = () => {
        let followUps: IDoctorCheckInInfo = ModelFactory.createNewDoctorCheckinInfo();
        if (!_.isEmpty(this.props.planDetails) && !_.isEmpty(this.props.planDetails.consultationsByLifestyleCoach)) {
            _.map(this.props.planDetails.consultationsByLifestyleCoach, (consultation: ConsultationPrescriptionItemRequest) => {
                if (!_.isEmpty(consultation.activities) && consultation.activities[0].checkinType === CheckinType.FOLLOWUP)
                    followUps = ModelFactory.getAlbusReferralFromConsultationPlan(consultation);
            })
        }
        return followUps;
    }

    getNewConfigGoals = () => {
        let allGoals: any[] = []
        if (this.props.planDetails && !_.isEmpty(this.props.planDetails.healthTarget)) {
            this.props.planDetails.healthTarget.goals.forEach((goal: any) => {
                allGoals.push(goal)
            })
        }
        return {
            healthTarget: {
                goals: allGoals
            }
        }
    }

    render() {
        const editedBy: IEditedBy = AppUtils.isDefined(this.props.accountData) ? AppUtils.getEditedBy(this.props.accountData) : null;
        const hasPatientDetails: boolean = AppUtils.isDefined(this.props.patientDetails);
        const patientId: number = hasPatientDetails ? Number(this.props.patientDetails.curefitUserId) : null;
        const secondaryPatientId: string = hasPatientDetails ? this.props.patientDetails.id.toString() : null;
        const fitnessPatientPlan = AppUtils.isDefined(this.props.planDetails) && !_.isEmpty(this.props.planDetails.fitnessPlan) ? this.props.planDetails.fitnessPlan : {};
        const mindfulnessPatientPlan = AppUtils.isDefined(this.props.planDetails) && !_.isEmpty(this.props.planDetails.mindfulnessPlan) ? this.props.planDetails.mindfulnessPlan : {};
        const habitsPlan = AppUtils.isDefined(this.props.planDetails) && this.props.planDetails.habits ? this.props.planDetails.habits : {};
        // const patientGoals = !_.isEmpty(this.props.patientGoalsData) ? this.props.patientGoalsData.map(item => item.userGoal).filter(item => item.userGoalType === "PRIMARY") : [];
        console.log("GOALS RECEIVED", this.props.patientGoalsData);
        return (
            <div className="patient-lifestyle-container patient-info-section">

                <div className="patient-section-header">Lifestyle</div>
                {
                    this.state.isLoadingData && <div>Loading...</div>
                }

                {
                    !this.state.isLoadingData &&
                    <div className={"lifestyle-info-container"}>
                        <LCGoalEditViewCont newConfigData={this.getNewConfigGoals()} staticGoals={this.props.staticGoals} staticMetrics={this.props.staticMetrics} appointmentId={null} displayMode={EditViewDisplayMode.VIEW}/>

                        <DietPlanEditViewCont displayMode={EditViewDisplayMode.VIEW} editedBy={editedBy} patientId={patientId} secondaryPatientId={secondaryPatientId} patientDietPlan={this.getDietPrescriptionFromPlan()} staticMealSlots={["BREAKFAST"]} staticMealPreferences={[]}/>

                        <FitnessPlanEditViewCont displayMode={EditViewDisplayMode.VIEW} editedBy={editedBy} patientId={patientId} secondaryPatientId={secondaryPatientId} patientFitnessPlans={fitnessPatientPlan}/>

                        <MindfulnessPlanEditViewCont displayMode={EditViewDisplayMode.VIEW} editedBy={editedBy} patientId={patientId} secondaryPatientId={secondaryPatientId} patientMindfulnessPlans={mindfulnessPatientPlan}/>

                        <HabitsPlanEditViewCont displayMode={EditViewDisplayMode.VIEW} editedBy={editedBy} patientId={patientId} secondaryPatientId={secondaryPatientId} patientHabitsPlan={habitsPlan}/>

                        {/*<AdditionalInstructionsEditViewCont displayMode={EditViewDisplayMode.VIEW} patientId={patientId} secondaryPatientId={secondaryPatientId} patientReferrals={this.generatePatientReferrals()} patientFollowUp={this.generatePatientFollowUps()} staticSpecialities={} consultationId={} doctorProfile={} isSelf={}/>*/}
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) =>  {
    return {
        patientDetails: state.patientCompleteInfo.profile,
        accountData: state.accountData,
        planDetails: state.patientCompleteInfo.patientPlan,
        // patientGoalsData: state.patientCompleteInfo.patientGoals,
        // staticGoals: state.allStaticDataNew.goals,
        staticMetrics: state.allStaticDataNew.metrics,
        // patientMetrics: state.patientCompleteInfo.patientMetrics
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getPatientPlanForView: (secondaryUserId: string) => PatientCompleteInfoActions.getPatientPlanForView(dispatch, secondaryUserId),
        getPatientMetrics: (metricReq: IMetricOptions) => PatientCompleteInfoActions.getPatientMetrics(dispatch, metricReq),
        fetchPlanStaticData: () => AllStaticDataActions.fetchPlanStaticData(dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientLifestyleContainer);
